import {ChangeDetectionStrategy, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatTab, MatTabGroup, MatTabLabel} from "@angular/material/tabs";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-garden',
    templateUrl: './garden.component.html',
    imports: [
        MatTabGroup,
        MatTab,
        TranslatePipe,
        MatTabLabel
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./garden.component.scss']
})
export class GardenComponent implements OnInit {

    gardenTabIndex = 0;

    gardenEntries: string [] = ["blossom", "root", "leaf", "fruit"]

    constructor(
        @Inject(MAT_DIALOG_DATA) public gardenId: string
    ) {
    }

    ngOnInit(): void {
        this.initActiveTab();
    }

    private initActiveTab() {
        const tabIndex = this.gardenEntries.indexOf(this.gardenId, 0)
        this.gardenTabIndex = tabIndex
    }

}
